var map = {
	"./bol.png": 620,
	"./dpd.png": 621,
	"./homerr.png": 622,
	"./postnl.png": 290
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 772;


//////////////////
// WEBPACK FOOTER
// ./src/orders/shipping-provider-icons ^\.\/.*\.png$
// module id = 772
// module chunks = 1